import {CategoryList} from 'components/category-list';
import {Breadcrumbs} from 'components/breadcrumbs';
import {DiscountList} from 'components/discount-list';
import {LocationList} from 'components/location-list';

export const HomePage = () => {
  const location = localStorage.getItem('location');

  //    This ILN was changed, so to not disrupt work on kiosks,
  //    this ILN will have a hardcoded change
  if (location === '4750959000250') {
    localStorage.setItem('location', '4750959000472')
    window.location.reload();
  }
  return (
    <>
      <Breadcrumbs />
      {location ? (
        <>
          <CategoryList limit={5} />
          <DiscountList limit={50} />
        </>
      ) : (
        <LocationList />
      )}
    </>
  );
};
